import Vue from "vue";
import VueI18n from "vue-i18n";
import { GetQueryString } from "@/utils/utils";

Vue.use(VueI18n);

// 多语言设置
const i18n = new VueI18n({
  locale: GetQueryString("lang") == "en" ? "en" : "zh", // 语言标识
  messages: {
    zh: require("./lang/zh"),
    en: require("./lang/en")
  }
});

export default i18n;
